import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import packageJson from '../package.json';
import App from './App';
import Notification from './components/common/Notification';
import { NotificationContextProvider } from './contexts/NotificationContextProvider';
import { ThemeContextProvider } from './contexts/ThemeContextProvider';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { store } from './store/store';

const appVersion = 'kitze@' + packageJson.version;

Sentry.init({
  dsn: 'https://5ac8b96b19276d1328619195bddd25aa@o4507284505886720.ingest.de.sentry.io/4507284508180560',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  sampleRate: 1.0,
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  release: appVersion,
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <ThemeContextProvider>
    <NotificationContextProvider>
      <Provider store={store}>
        <App />
      </Provider>
      <Notification />
    </NotificationContextProvider>
  </ThemeContextProvider>
);

serviceWorkerRegistration.register();
